import memoizeOne from 'memoize-one';
import { createSimpleColumns } from 'console/tabs/maintenance/tables/TableFunctions';
import { ColumnDataType, ColumnSortDirection } from './tubular-types/column';
import { createColumn } from './tubular-types/columnUtils';
export const generateColumns = memoizeOne((columns_name) => columns_name.map((column, index) => {
    if (index === 0) {
        return createColumn('column-0', {
            label: column,
            isKey: true,
            dataType: ColumnDataType.String,
            sortDirection: ColumnSortDirection.Ascending,
            sortOrder: 1,
            filterable: true,
            sortable: true,
            searchable: true,
        });
    }
    return createSimpleColumns(`column-${index}`, column);
}));
export const generateColumnsWithDeleteButton = memoizeOne((columns_name) => [
    ...generateColumns(columns_name),
    createColumn('delete_button', {
        label: ' ',
        filterable: false,
        sortable: false,
        searchable: false,
        visible: false,
    }),
]);
